import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { FormComponentLookup, FormEntryComponentClass } from '@ptl/forms';
import { EligibilityResponsePayload } from 'src/app/angular-elements/on-exchange-enrollment/interfaces/eligibility.interface';
import { OnExchangeEligibilityStateStructure, ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME } from 'src/app/angular-elements/on-exchange-enrollment/reducers/eligibility.reducer';
import { DateService } from 'src/app/shared/services/date.service';
//import * as moment from 'moment';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { EligibilityManagerService } from 'src/app/angular-elements/on-exchange-enrollment/services/eligibility-manager.service';
import { PageIndividualOnExchangePlanEnrollmentService } from '../../services/page-individual-on-exchange-plan-enrollment.service';
import { environment } from 'src/environments/environment';
import { NotificationAndAuthorizationFormControlsAsJson } from 'src/app/angular-elements/shared/interfaces/on-exchange-eligibility-form.interface';

interface NotificationAndAuthorizationFormControls {
  attestation: AbstractControl;
}

// interface NotificationAndAuthorizationFormControlsAsJson {
//   attestation: boolean;
// }

@FormComponentLookup('marketplace-notification-and-authorization')
@Component({
    selector: 'app-marketplace-notification-and-authorization',
    templateUrl: './marketplace-notification-and-authorization.component.html',
    styleUrls: ['./marketplace-notification-and-authorization.component.scss'],
    standalone: false
})
export class MarketplaceNotificationAndAuthorizationComponent extends FormEntryComponentClass implements OnInit, OnDestroy {

  notificationAndAuthorizationForm: UntypedFormGroup;
  notificationAndAuthorizationFormChangesSubscription: Subscription;

  nameNodeValue: string;
  signOrSubmissionDate: string;
  aspId: string;

  constructor(
    private fb: UntypedFormBuilder,
    private dateService: DateService,
    private eligibilityManagerService: EligibilityManagerService,
    private pageIndividualOnExchangePlanEnrollmentService: PageIndividualOnExchangePlanEnrollmentService
  ) {
    super();
  }

  get notificationAndAuthorizationFormControls(): NotificationAndAuthorizationFormControls {
    return this.notificationAndAuthorizationForm.controls as unknown as NotificationAndAuthorizationFormControls;
  }

  ngOnDestroy() {
    this.notificationAndAuthorizationFormChangesSubscription?.unsubscribe();
  }

  ngOnInit(): void {

    this.aspId = environment.initData.brand.ASPID;

    this.signOrSubmissionDate = moment(this.dateService.getNow()).format('MM/DD/YYYY');

    const eligibilityState: OnExchangeEligibilityStateStructure
      = this.reducerUtilityService.getComponentStates()[ON_EXCHANGE_ELIGIBILITY_REDUCER_NAME];
    const matchedProspects = eligibilityState.prospects.filter(p => eligibilityState.currentProspectId === p.prospectId );

    if (matchedProspects.length > 0) {
      const prospect = matchedProspects[0];

      const primary = this.eligibilityManagerService.getPrimaryApplicant();
      const primaryName = primary.fullName;
      this.nameNodeValue = `${primaryName.firstName} ${primaryName.lastName} ${primary.dateOfBirth}`;

      /** Create Form */
      this.notificationAndAuthorizationForm = this.fb.group({});
      /** Watch Form */
      this.setupSubscription();
      /** Populate Form */
      this.setupForm(prospect.data);
    }

  }

  setupSubscription() {

    this.notificationAndAuthorizationFormChangesSubscription = this.notificationAndAuthorizationForm.valueChanges
    .pipe(debounceTime(300))
    .subscribe((v: NotificationAndAuthorizationFormControlsAsJson) => {

      const dynamicObject = {};
      dynamicObject[this.entry.formControlAttributes.formControlName] = v;

      /** Update global form (trigger save to state) */
      this.form.patchValue(dynamicObject);
      this.pageIndividualOnExchangePlanEnrollmentService.reportValidity(this.notificationAndAuthorizationForm, this.entry);

    });

  }

  setupForm(enrollData: EligibilityResponsePayload) {

    /** Attestion Checkbox */
    this.notificationAndAuthorizationForm.addControl(
      'attestation',
      this.fb.control(false, [Validators.requiredTrue])
    );

    this.notificationAndAuthorizationForm.updateValueAndValidity();
    this.pageIndividualOnExchangePlanEnrollmentService.reportValidity(this.notificationAndAuthorizationForm, this.entry);
  }



}
